export default __webpack_public_path__ + "static/media/logo_stg.cd07d2e0.jpg";